import { Table } from 'antd'

import {
  useJobMasking,
  maskDetailColumns,
} from '../../contexts/JobMaskingContext'
import useTranslations from '../../hooks/useTranslations'

const ANTDTable = ({ pagination, showSizeChanger = false, ...props }) => {
  const { t } = useTranslations()
  const masked = useJobMasking()
  return (
    <Table
      {...props}
      columns={
        masked ? maskDetailColumns(props.columns || [], masked) : props.columns
      }
      pagination={pagination && { showSizeChanger, ...pagination }}
      locale={{ emptyText: t('txt_NoData') }}
    />
  )
}

export default ANTDTable

const ANTDTableRow = ({ ...props }) => {
  return <Table.Summary.Row {...props} />
}
const ANTDTableCell = ({ ...props }) => {
  return <Table.Summary.Cell {...props} />
}
export { ANTDTableRow, ANTDTableCell }
